module.exports = __webpack_public_path__ + "static/media/Fat Choy Choy Sun.f682fb98.png";